<boi-form-textarea [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
  [labelName]="referenceDataLabels.PleaseProvideAnyAdditionalInfo" [propertyNames]="['AdditionalInformation']"
  [(value)]="mortgageApplication.AdditionalInformation" [fieldMaxLength]="1500"></boi-form-textarea>